import React, { Component } from 'react';
import { compose } from 'redux';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import Select from './Select';
import { bookingFormInitialValues } from '../store/reducers';
import { setStep } from '../store/actions';
import BoardBases from './BoardBases/index';
import DietRestrictions from './DietRestrictions/index';
import SelectedRooms from './SelectedRooms/index';
import faUmbrella from '@fortawesome/fontawesome-pro-light/faUmbrella';
import faUtensils from '@fortawesome/fontawesome-pro-light/faUtensils';
import StayType from '../enums/StayType';
import { getBoardBaseOptions, isAutoExtraFeeApplicable, isRealBoardBaseSelected, isWithoutAccommodation } from '../apiHelpers';
import { formatPrice, SANDAMIANO_HOTEL_ID } from '../utils';
import withLocalize from '../withLocalize';

class Step2 extends Component {

	componentWillMount() {
		this.props.dispatch(setStep(2));
	}

	render() {
		const { apiRoomsResponse, boardBaseByGuestType, boardBases, dietRestrictions, formValues, hotelId, totalNoOfGuests, translate: t, translatePropertyValue, translateSelectOptions } = this.props;
		const boardBaseOptions = getBoardBaseOptions(boardBases, formValues.currency, t, hotelId);
		const withoutAccommodation = isWithoutAccommodation(formValues);

		// sandamiano: automatické příplatky/slevy vybraného pobytového balíčku - jen informativní, nezměnitelný výběr
		const autoExtraFees = hotelId === SANDAMIANO_HOTEL_ID && apiRoomsResponse
			? apiRoomsResponse.extraFees.filter(extraFee => isAutoExtraFeeApplicable(formValues.rooms, extraFee))
			: [];

		return (
			<div className="container">
				<SelectedRooms/>

				<div className="select-row">
					{autoExtraFees.map(extraFee => {
						const priceLabel = typeof extraFee.price === 'object'
							? `${formatPrice(extraFee.price[formValues.currency.id] * totalNoOfGuests, formValues.currency)}${t('Step2.extraFee.perEvent')}`
							: `${extraFee.price} %`;

						return (
							<Select
								key={extraFee.id}
								disabled
								label={translatePropertyValue(extraFee.name)}
								className="select-row__item select-row__item--wide"
								options={[{ value: extraFee.id, label: priceLabel }]}
								defaultValue={extraFee.id}
							/>
						);
					})}

					{!withoutAccommodation && hotelId !== SANDAMIANO_HOTEL_ID &&
					<Field
						component={Select}
						name="stayType"
						label={t('Step2.stayType')}
						className="select-row__item select-row__item--wide"
						fontAwesomeIcon={faUmbrella}
						options={translateSelectOptions(StayType.getOptions())}
					/>
					}

					{!boardBaseByGuestType && boardBaseOptions.length > 0 &&
					<Field
						component={Select}
						name="boardBase"
						label={t('Step2.boardBase')}
						className="select-row__item select-row__item--wide"
						fontAwesomeIcon={faUtensils}
						options={boardBaseOptions}
					/>
					}
				</div>

				{boardBaseByGuestType && boardBaseOptions.length > 0 &&
				<BoardBases/>
				}

				{hotelId === SANDAMIANO_HOTEL_ID && dietRestrictions && Object.keys(dietRestrictions).length > 0 && isRealBoardBaseSelected(formValues) &&
				<DietRestrictions/>
				}
			</div>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		apiRoomsResponse: state.app.apiRoomsResponse,
		boardBaseByGuestType: state.app.boardBaseByGuestType,
		boardBases: state.app.boardBases,
		dietRestrictions: state.app.dietRestrictions,
		hotelId: state.app.hotelId,
		totalNoOfGuests: state.app.totalNoOfGuests,
	})),
	withLocalize,
)(Step2);



// WEBPACK FOOTER //
// ./src/components/Step2.jsx